import styled from "styled-components";

const COLOR_WHITE = "var(--primary-neutral-white)";
const COLOR_NIGHTSHADE_800 = "var(--primary-neutral-nightshade-800)";
const COLOR_NIGHTSHADE_600 = "var(--primary-neutral-nightshade-600)";

export const TextBlockWrapper = styled.div`
	p {
		color: ${({ isDarkBg }) =>
			!isDarkBg ? `${COLOR_NIGHTSHADE_600}` : `${COLOR_WHITE}`};
	}

	.label-overflow {
		display: flex;
		gap: 0.5rem;
		flex-wrap: wrap;
		justify-content: ${({ style }) => style?.textAlign};
		margin-bottom: 16px;
	}

	.text-items,
	.headlines {
		${({ isDarkBg }) =>
			isDarkBg &&
			`
      color: ${COLOR_WHITE};
      & a{
        color: ${COLOR_WHITE};
      }
    `}
	}
`;

export const CTAWrapper = styled.div`
	${({ align }) =>
		align &&
		`
      text-align: ${align};
    `}
`;
